import { render, staticRenderFns } from "./AgregaCredencial.vue?vue&type=template&id=28b87779"
import script from "./AgregaCredencial.vue?vue&type=script&lang=js"
export * from "./AgregaCredencial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports